const state = {
  all: []
}

const getters = {}

const actions = {
  getEventTypes ({ commit }) {
    axios
      .get("/event-types")
      .then(response => (commit('setEventTypes', response.data)));
  }
}

const mutations = {
  setEventTypes (state, data) {
    state.all = data;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
